/* @flow */

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const RESET_USER = 'RESET_USER';

export const FETCH_USER_STATISTICS_REQUEST = 'FETCH_USER_STATISTICS_REQUEST';
export const FETCH_USER_STATISTICS_SUCCESS = 'FETCH_USER_STATISTICS_SUCCESS';
export const FETCH_USER_STATISTICS_FAILURE = 'FETCH_USER_STATISTICS_FAILURE';

export const FETCH_USER_CAN_CREATE_GROUP_TOPIC_REQUEST =
  'FETCH_USER_CAN_CREATE_GROUP_TOPIC_REQUEST';
export const FETCH_USER_CAN_CREATE_GROUP_TOPIC_SUCCESS =
  'FETCH_USER_CAN_CREATE_GROUP_TOPIC_SUCCESS';
export const FETCH_USER_CAN_CREATE_GROUP_TOPIC_FAILURE =
  'FETCH_USER_CAN_CREATE_GROUP_TOPIC_FAILURE';

export const PATCH_USER_REQUEST = 'PATCH_USER_REQUEST';
export const PATCH_USER_SUCCESS = 'PATCH_USER_SUCCESS';
export const PATCH_USER_FAILURE = 'PATCH_USER_FAILURE';

export const PATCH_USER_SIGNUP_SUCCESS = 'PATCH_USER_SUCCESS';

export const FETCH_USER_ACTIVITY_REQUEST = 'FETCH_USER_ACTIVITY_REQUEST';
export const FETCH_USER_ACTIVITY_SUCCESS = 'FETCH_USER_ACTIVITY_SUCCESS';
export const FETCH_USER_ACTIVITY_FAILURE = 'FETCH_USER_ACTIVITY_FAILURE';

export const UPDATE_AVATAR_REQUEST = 'UPDATE_AVATAR_REQUEST';
export const UPDATE_AVATAR_SUCCESS = 'UPDATE_AVATAR_SUCCESS';
export const UPDATE_AVATAR_FAILURE = 'UPDATE_AVATAR_FAILURE';

export const SIMULATE_USER_TOPIC_KEYWORDS_REQUEST =
  'SIMULATE_USER_TOPIC_KEYWORDS_REQUEST';
export const FETCH_USER_TOPIC_KEYWORDS_REQUEST =
  'FETCH_USER_TOPIC_KEYWORDS_REQUEST';
export const FETCH_USER_TOPIC_KEYWORDS_SUCCESS =
  'FETCH_USER_TOPIC_KEYWORDS_SUCCESS';
export const FETCH_USER_TOPIC_KEYWORDS_FAILURE =
  'FETCH_USER_TOPIC_KEYWORDS_FAILURE';

export const SIMULATE_USER_INTERESTS_REQUEST =
  'SIMULATE_USER_INTERESTS_REQUEST';
export const FETCH_USER_INTERESTS_REQUEST = 'FETCH_USER_INTERESTS_REQUEST';
export const FETCH_USER_INTERESTS_SUCCESS = 'FETCH_USER_INTERESTS_SUCCESS';
export const FETCH_USER_INTERESTS_FAILURE = 'FETCH_USER_INTERESTS_FAILURE';
